import { User } from './user';

export interface Session {
  isLoggedIn: boolean;
  user: User;
}
